"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    form: {
      type: Object,
      default: {}
    },
    powerInfo: {
      type: Object,
      default: {}
    },
    name: {
      type: String,
      default: 'bao'
    }
  },
  data: function data() {
    return {};
  },
  watch: {
    'form.store_id': {
      immediate: true,
      handler: function handler() {
        if (this.form[this.name + '_relative_percent'] > 0) this.countPercent();
        if (this.form[this.name + '_virtual_divide'] == undefined) {
          var percent = {};
          percent[this.name + '_virtual_divide'] = 0;
          percent[this.name + '_relative_percent'] = 0;
          percent[this.name + '_relative_divide'] = 1;
          this.$emit('setDefaultPercent', percent);
        }
      }
    }
  },
  computed: {
    siteInfo: function siteInfo() {
      var siteInfo = this.$store.getters.siteInfo;
      return siteInfo;
    },
    agent_id: function agent_id() {
      var agent_id = (0, _auth.getToken)('agent_id');
      return agent_id;
    }
  },
  mounted: function mounted() {},
  methods: {
    /**
     * 计算真实分成比例
     */
    countPercent: function countPercent(value) {
      var form = this.form;
      value = parseFloat(form[this.name + '_relative_percent']);
      if (!value || value > 100 || value < 0) {
        this.$message({
          message: '分成数值须在0-100之间',
          type: 'error'
        });
        return;
      }
      var v = value * this.powerInfo["".concat(this.name, "_percent")] / 100;
      this.$set(this.form, "".concat(this.name, "_relative_zs"), v.toFixed(2));
    },
    virtualChange: function virtualChange(v) {
      if (v == 1) this.$set(this.form, "".concat(this.name, "_relative_divide"), 1);
    },
    /**
     * 检测套餐是否隐藏了几个，限制不能全部隐藏
     * @param {Object} arr
     * @param {Object} item
     */
    checkFeeShow: function checkFeeShow(arr, item) {
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'rent_unit_show';
      var feeShowNum = 0;
      var v = item[key] == 0 ? 1 : 0;
      arr.map(function (i) {
        if (i[key] == 1) feeShowNum++;
      });
      if (feeShowNum < 2 && v == 0) {
        this.$message({
          message: '最少显示一个套餐',
          type: 'error'
        });
      } else {
        return item[key] = v;
      }
    }
  }
};